import { oofDtos } from '@vectronic/openApi-admin';

export class OrderItemConfigurationStatusMapper {
  static getStatusLevel(
    orderItemConfigurationStatus: oofDtos.OrderItemConfiguration.StatusEnum,
  ): number {
    switch (orderItemConfigurationStatus) {
      case oofDtos.OrderItemConfiguration.StatusEnum.Incomplete:
        return 1;
      case oofDtos.OrderItemConfiguration.StatusEnum.Fulfilled:
        return 2;
      case oofDtos.OrderItemConfiguration.StatusEnum.ConfirmedBySales:
        return 3;
      case oofDtos.OrderItemConfiguration.StatusEnum.ReadyForProduction:
        return 4;
      case oofDtos.OrderItemConfiguration.StatusEnum.InProduction:
        return 5;
      case oofDtos.OrderItemConfiguration.StatusEnum.Packed:
        return 6;
      case oofDtos.OrderItemConfiguration.StatusEnum.Shipped:
        return 7;
      case oofDtos.OrderItemConfiguration.StatusEnum.Canceled:
        return 8;
      default:
        const unreachable: never = orderItemConfigurationStatus;
        throw new Error(`Unhandled status: ${unreachable}`);
    }
  }
}
